import { Command, Option } from 'commander';
import { getV2Client } from '../../api/v2-client.js';
import type { IV2Client } from '../../api/v2-client.js';
import { handleV2Error } from '../../handle-error.js';
import { Output } from '../../output.js';
import { addGridOption, gridSlug, type GridOpts } from '../../grid-opt.js';

interface ListOpts extends GridOpts { status?: string; json?: boolean; }

export async function runAdminInvitations(opts: ListOpts, client?: IV2Client): Promise<void> {
  const out = Output.fromOpts({ json: !!opts.json, quiet: false });
  const c = client ?? await getV2Client(gridSlug(opts));
  const status = opts.status ?? 'pending';
  const resp = await c.get<{ invitations: Array<{ invitation_id: string; invited_email: string; role: string; status: string; created_at: string; expires_at: string }> }>(
    '/api/v2/invitations', { status, limit: 100 });
  out.json(() => resp.invitations);
  out.human(() => {
    if (resp.invitations.length === 0) return `No ${status} invitations.`;
    return resp.invitations.map((i) => `  - ${i.invited_email} — ${i.role} — ${i.status} — expires ${i.expires_at}`).join('\n');
  });
}

export const adminInvitationsCommand = new Command('invitations')
  .description('List invitations in the active grid (admin only)')
  .addOption(new Option('--status <s>', 'Filter by status').choices(['pending', 'accepted', 'expired', 'revoked', 'all']).default('pending'))
  .option('--json', 'JSON output');
addGridOption(adminInvitationsCommand, 'Override active grid');
adminInvitationsCommand
  .action(async (opts: ListOpts) => {
    try { await runAdminInvitations(opts); }
    catch (err) { await handleV2Error(err, { json: !!opts.json }); }
  });
